import React from 'react';
import moment from 'moment';
import { CURRENCY, FORMAT_NUMBER } from '../libs/utils/Const';

const renderTableBody = (headers, data, checkbox, openDocumentDetails, view) => {
    let body = "";
    body = data.map((register, index) => {

        return (
            <tr key={index}>
                <td className="sticky-column" >
                    <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)} />
                </td>
                {headers[0].value && <td className="text-center">{register?.Series ?? ''}</td>}
                {headers[1].value && <td className="text-center ">{register.DocStatus === 'O' ? "Abierto" : "Cerrado"}</td>}
                {headers[2].value && <td className="text-center font-weight-bold" >{register?.DocNum}</td>}
                {headers[3].value && <td className="text-center font-weight-bold" >{register?.NumAtCard}</td>}
                {headers[4].value && <td className="text-center">{moment(register.DocDate).format("DD-MM-YYYY")}</td>}
                {headers[5].value && <td className="text-center">{register?.UserCode}</td>}
                {headers[6].value && <td className="text-center">{register?.UserName}</td>}
                {headers[7].value && <td className="text-center">{register?.Comments}</td>}
                {headers[8].value && <td className="text-center">{FORMAT_NUMBER.new(register?.DocTotal || 0, " $ ")}</td>}
                <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }} >
                    <button type="button" className="btn btn-timbra-one btn-sm botonCorrect" onClick={() => openDocumentDetails(register)} style={{ fontWeight: '500' }}>
                        <i className="far fa-file-alt"></i> Ver Detalles
                    </button>
                </td>
            </tr>
        )

    })
    return body;
};

const renderTable = (headers, data, checkbox, openDocumentDetails, view) => {
    let header = "";
    let body = "";
    header = <tr>
        <td className="sticky-column" style={{ backgroundColor: "#e9ecef" }} >
            <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" value="second_checkbox" onChange={(event) => checkbox.selectAll(event.target.checked)} />
        </td>
        {headers[0].value && <td>{headers[0].title}</td>}
        {headers[1].value && <td>{headers[1].title}</td>}
        {headers[2].value && <td>{headers[2].title}</td>}
        {headers[3].value && <td>{headers[3].title}</td>}
        {headers[4].value && <td>{headers[4].title}</td>}
        {headers[5].value && <td>{headers[5].title}</td>}
        {headers[6].value && <td>{headers[6].title}</td>}
        {headers[7].value && <td>{headers[7].title}</td>}
        {headers[8].value && <td>{headers[8].title}</td>}
        <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>
    </tr>;

    body = renderTableBody(headers, data, checkbox, openDocumentDetails, view);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};

export const renderTableSuggestRefill = (headers, data, checkbox, openDocumentDetails, view) => {
    return renderTable(headers, data, checkbox, openDocumentDetails, view);
}
